import { useRef } from 'react'

const useConfetti = () => {
  const savedTimer = useRef()
  const confetti = (show) => {
    if (show) {
      savedTimer.current = setTimeout(() => {
        confetti(false)
      }, 10000)
      let h = 60
      const d = (n) => Math.floor(Math.random() * n)
      const k = (c) => {
        const s = document.createElement('style')
        s.classList.add('ds-confetti')
        if (window.attachEvent && !window.opera) {
          s.styleSheet.cssText = c
        } else {
          s.appendChild(document.createTextNode(c))
        }
        document.getElementsByTagName('head')[0].appendChild(s)
      }
      k(
        '@keyframes u{0%{transform:rotate(0deg);}25%{transform:rotate(4deg);}50%{transform:rotate(0deg);}75%{transform:rotate(-4deg);}100%{transform:rotate(0deg);}};'
      )
      k(
        `@keyframes m{0%{margin-top:2vh;opacity:0;transform-style: preserve-3d;perspective: ${
          d(20) + 6
        }px;transform: rotateX(-80deg);}20%{opacity:0.8;margin-top:0vh;margin-left:0vw;transform-style: preserve-3d;perspective: ${
          d(20) + 6
        }px;transform: rotateX(0deg) rotate(${d(360)}deg);}100%{opacity:0.2;margin-top:100vh;margin-left:${d(
          4
        )}vw;transform: rotateX(360deg) rotate(1080deg);}};`
      )
      const w = document.createElement('div')
      w.id = 'dsConfetti'
      w.style =
        'z-index:1000000;animation:u 20s ease-in;position:fixed;top:0;right:0;bottom:0;left:0;pointer-events:none;'
      document.body.appendChild(w)
      while (h--) {
        const o = document.createElement('div')
        o.style = `pointer-events:none;opacity:0;animation:m ${d(6) + 2}s ease-in ${d(
          2000
        )}ms;z-index:1000;position:fixed;top:${d(40)}vh;left:${d(100)}vw;font-size:${d(16) + 8}px;color:${
          [
            '#ED5565',
            '#FC6E51',
            '#FFCE54',
            '#A0D468',
            '#48CFAD',
            '#4FC1E9',
            '#5D9CEC',
            '#4A89DC',
            '#AC92EC',
            '#EC87C0',
          ][d(10)]
        };`
        o.innerHTML = ['▀', '▃', '▅', '▇', '▋', '▗'][d(6)]
        w.appendChild(o)
      }
    } else {
      clearTimeout(savedTimer.current)
      const confettiElement = document.getElementById('dsConfetti')
      if (confettiElement) {
        confettiElement.remove()
      }
      const styles = document.querySelectorAll('.ds-confetti')
      if (styles) {
        for (let i = 0; i < styles.length; i++) {
          styles[i].remove()
        }
      }
    }
  }
  return confetti
}
const dummy = () => {}

export { useConfetti, dummy }
